const css = `._table_1j4qh_1 thead tr th {
  border: 0 none transparent;
  border-bottom: 1px solid var(--border-color);
  font-weight: 500;
}
._table_1j4qh_1 tbody tr td {
  border: 0 none transparent;
  border-right: 1px solid var(--border-color);
}
._table_1j4qh_1 tbody tr td:last-child {
  border-right: 0 none transparent;
}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
export default {
  "table": "_table_1j4qh_1"
};